import { motion } from "framer-motion";

function Experience() {
  const experience = [
    {
      company: "Publicis Sapient",
      role: "React Native Developer",
      duration: "Feb 2024 – Present",
      points: [
        "Developed scalable mobile features using React Native.",
        "Integrated REST APIs and improved application performance.",
        "Collaborated with cross-functional teams to deliver high-quality mobile applications.",
      ],
    },
    {
      company: "Helius Technology",
      role: "React Native Developer",
      duration: "Sep 2023 – Feb 2024",
      points: [
        "Built a mobile insurance application using React Native.",
        "Implemented secure authentication and API integrations.",
      ],
    },
    {
      company: "Diamante Block Stack",
      role: "React Native Developer",
      duration: "Oct 2022 – Sep 2023",
      points: [
        "Developed blockchain wallet applications.",
        "Implemented multi-network wallet support and transaction features.",
      ],
    },
    {
      company: "Cineama Clubby Pvt Ltd",
      role: "React Native Developer",
      duration: "Mar 2020 – Oct 2022",
      points: [
        "Developed an e-commerce mobile application.",
        "Integrated payment gateways and improved user experience.",
      ],
    },
  ];

  return (
    <section className="min-h-screen bg-gradient-to-br from-[#0b1220] via-[#0f1d3a] to-[#0a1f44] text-white pt-40 pb-20">

      <div className="max-w-5xl mx-auto px-6">

        <h1 className="text-4xl font-bold text-center mb-16">
          Work Experience
        </h1>

        <div className="relative border-l border-blue-500/60 pl-6">

          {experience.map((job, index) => (
            <motion.div
              key={index}
              className="relative mb-12"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ y: -4 }}
            >

              {/* Timeline Dot */}
              <div className="absolute -left-[30px] top-6 w-4 h-4 bg-blue-500 rounded-full shadow-[0_0_12px_rgba(59,130,246,0.9)]"></div>

              {/* Card */}
              <div className="bg-[#1b2433]/90 backdrop-blur-md p-6 rounded-xl shadow-[0_0_40px_rgba(59,130,246,0.15)] hover:shadow-[0_0_60px_rgba(59,130,246,0.35)] transition">

                <h2 className="text-xl font-semibold">
                  {job.company}
                </h2>

                <p className="text-blue-300 text-sm mt-1">
                  {job.role} • {job.duration}
                </p>

                <ul className="mt-4 text-gray-400 space-y-2 list-disc list-inside">
                  {job.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

              </div>

            </motion.div>
          ))}

        </div>

      </div>

    </section>
  );
}

export default Experience;